import script from "./tool-footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./tool-footer.vue?vue&type=script&setup=true&lang=ts"

import "./tool-footer.vue?vue&type=style&index=0&id=09a63244&lang=scss"

const __exports__ = script;

export default __exports__